ALLOWED_CONTROLLER = 'data_maps'
ALLOWED_ACTIONS = ['show']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  backendData = JSON.parse($("#map-div").attr('data-backend-data'))
  maxColorNumber = 255
  highestCount = parseInt($("#map-div").attr('data-highest-count'))
  showList = $("#map-div").attr('data-show-list') == "true"
  locations = JSON.parse($("#map-div").attr('data-locations'))
  currentYear = $("#map-div").attr('data-current-year')
  currentZoomLevel = $("#map-div").attr('data-current-zoom-level')

  CustomMarker = (latlng, map, options) ->
    @latlng = latlng
    @options = options
    @setMap(map)

  CustomMarker.prototype = new (google.maps.OverlayView)

  CustomMarker::draw = ->
    self = this
    marker = @marker
    label = @label

    if !marker
      if highestCount == 0
        colorNumber = maxColorNumber
      else
        colorNumber = maxColorNumber - Math.round(self.options.value / highestCount * maxColorNumber)

      marker = @marker = document.createElement('div')
      marker.className = 'marker'
      marker.style.backgroundColor = 'rgb(255,' + colorNumber + ',' + colorNumber + ')'
      marker.title = self.options.location_name + ' - ' + self.options.value

      if showList
        marker.innerHTML = self.options.reference
      else
        marker.innerHTML = self.options.value

      if typeof self.options.marker_id != 'undefined'
        marker.dataset.marker_id = self.options.marker_id

      panes = @getPanes()
      panes.overlayImage.appendChild(marker)

    point = @getProjection().fromLatLngToDivPixel(@latlng)

    if point
      marker.style.left = point.x - 10 + 'px'
      marker.style.top = point.y - 20 + 'px'

  CustomMarker::remove = ->
    if @marker
      @marker.parentNode.removeChild(@marker)
      @marker = null
    if @label
      @label.parentNode.removeChild(@label)
      @label = null

  CustomMarker::getPosition = ->
    @latlng



  initialize = ->
    if currentYear
      centerLocation = backendData[currentYear][locations[0].id]
      center = new (google.maps.LatLng)(centerLocation.latitude, centerLocation.longitude)
    else if backendData.no_year == undefined
      center = new (google.maps.LatLng)(0.0, 0.0)
    else
      centerLocation = backendData.no_year[locations[0].id]
      center = new (google.maps.LatLng)(centerLocation.latitude, centerLocation.longitude)

    mapOptions = {
      zoom: parseInt(currentZoomLevel),
      center: center
    }

    document.google_map = new (google.maps.Map)(document.getElementById('map-canvas'), mapOptions)

    if currentYear
      $.each backendData[currentYear], (key, marker) ->
        new CustomMarker(new (google.maps.LatLng)(marker.latitude, marker.longitude), document.google_map,
          marker_id: key
          value: marker.value
          location_name: marker.location_name
          reference: marker.reference)

      $("div[data-selector=year]").html($("#year").val())
    else
      $.each backendData.no_year, (key, marker) ->
        new CustomMarker(new (google.maps.LatLng)(marker.latitude, marker.longitude), document.google_map,
          marker_id: key
          value: marker.value
          location_name: marker.location_name
          reference: marker.reference)

  changeYear = ->
    $.each backendData[$("#year").val()], (key, marker) ->
      if highestCount == 0
        colorNumber = maxColorNumber
      else
        colorNumber = maxColorNumber - Math.round(marker.value / highestCount * maxColorNumber)

      color = 'rgb(255,' + colorNumber + ',' + colorNumber + ')'
      $('div[data-marker_id=' + key + ']').css(background: color)

      if showList
        $('td[data-id=' + key + ']').html(marker.value)
      else
        $('div[data-marker_id=' + key + ']').html(marker.value)

      currentNameArray = $('div[data-marker_id=' + key + ']').attr('title').split('-')
      currentNameArray.pop()
      $('div[data-marker_id=' + key + ']').attr 'title', currentNameArray.join('-') + '- ' + marker.value


  setCurrentZoomLevelAndSubmitForm = ->
    $("input#zoom_level").val(document.google_map.getZoom())
    $('form').submit()


  window.addEventListener('load', initialize())
  $('*[data-selector="change-year"]').on('change', changeYear)
  $('*[data-selector="submit-form"]').on('change', setCurrentZoomLevelAndSubmitForm)

$(document).ready(ready)
$(document).on('turbo:load', ready)
